module.exports = __webpack_public_path__ + "static/media/rhino-modal.2047c22d.gif";